"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _ProgressSummary = _interopRequireDefault(require("./ProgressSummary")),
    _fileTypeIconMap = _interopRequireDefault(require("../../../../../common/constants/fileTypeIconMap")),
    _utils = require("../../../../../common/utils");

require("../styles/_upload-item.scss");

var retryFile = (0, _memoizeOne["default"])(function (a, b, c) {
  return function (d) {
    var e = (0, _slicedToArray2["default"])(d.target.files, 1),
        f = e[0];
    return a(b, c, f);
  };
}),
    removeUploadItem = (0, _memoizeOne["default"])(function (a, b) {
  return function () {
    return a(b);
  };
});

function browseFiles(a) {
  return function () {
    var b = document.getElementById(a);
    return b && b.click();
  };
}

function UploadItem(a) {
  var b = a.filename,
      c = a.loadedPercent,
      d = a.loaded,
      e = a.status,
      f = a.totalSize,
      g = a.retry,
      h = a.remove,
      i = a.assetId,
      j = a.organisationId,
      k = a.metaData,
      l = c || Math.floor(100 * (d / f)),
      m = _fileTypeIconMap["default"][(0, _utils.getTypeFromAsset)({
    metaData: k,
    filename: b
  })],
      n = "".concat(i, "-upload-item}");

  return _react["default"].createElement("div", {
    className: "upload-item"
  }, "error" === e && g && i ? _react["default"].createElement("div", {
    className: "upload-item__reset-upload"
  }, _react["default"].createElement("input", {
    id: n,
    type: "file",
    onChange: retryFile(g, i, j)
  }), _react["default"].createElement(_uiKit.Button, {
    prefix: "folder",
    tooltipId: "".concat(n, "-tooltip"),
    tooltipLabel: "Browse for this file and resume uploading",
    tooltipPlace: "right",
    type: "TERTIARY",
    onClick: browseFiles(n)
  })) : _react["default"].createElement(_uiKit.Image, {
    defaultImageIcon: m,
    height: "40px",
    width: "40px",
    backgroundSize: "cover",
    rounded: !0
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("upload-item__details", {
      "upload-item__details--no-progress": 0 === d && "error" !== e
    }, {
      "upload-item__details--error": "error" === e
    })
  }, _react["default"].createElement("p", null, b), _react["default"].createElement(_ProgressSummary["default"], {
    loadedPercent: l,
    loaded: d,
    removeUploadItem: removeUploadItem(h, i),
    total: f,
    status: e
  })));
}

var _default = UploadItem;
exports["default"] = _default;